// /scover/member-portal/src/components/BackToTopButton.jsx
import React, { useState, useEffect } from 'react';
import './BackToTopButton.css';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <div className="back-to-top-container">
          <button className="back-to-top-button" onClick={scrollToTop}>
            <span className="arrow">^</span>
          </button>
          <span className="label">top</span>
        </div>
      )}
    </>
  );
};

export default BackToTopButton;